import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../core/domain/events/domain_event_provider';
import { ToDoEvent } from './todo_events';

@Injectable({ providedIn: 'root' })
export class ToDoEventProvider extends DomainEventProvider<ToDoEvent> {}
